import React from 'react';
import './StartEditingButton.css';

const StartEditingButton = () => {
  return (
    <button className="btn-start-editing">
      <span>Start Editing</span>
    </button>
  );
};

export default StartEditingButton;